import { env } from '@/lib/env';
import { getActiveWorkspaceId } from '@/lib/api/workspace-context';
import type { SnapshotListItem } from '../types';

export function authHeaders(token: string | null): Record<string, string> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  // Flat (non-/workspaces-scoped) routes resolve tenancy from this header;
  // a JWT without a workspace claim otherwise 400s with
  // WORKSPACE_CONTEXT_REQUIRED — which broke every snapshots/History read.
  const workspaceId = getActiveWorkspaceId();
  if (workspaceId) headers['X-Workspace-Id'] = workspaceId;
  return headers;
}

export async function fetchSnapshots(
  fetchFn: typeof fetch,
  pageObjectId: string,
  token: string | null,
): Promise<SnapshotListItem[]> {
  const res = await fetchFn(
    `${env.apiBaseUrl}/pages/${encodeURIComponent(pageObjectId)}/snapshots`,
    { headers: authHeaders(token) },
  );
  if (!res.ok) throw new Error(`Failed to load snapshots: ${res.status}`);
  const body = await res.json();
  return (body.items as SnapshotListItem[]) || [];
}

export async function fetchSnapshotHtml(
  fetchFn: typeof fetch,
  pageObjectId: string,
  snapshotId: string,
  token: string | null,
): Promise<string> {
  const res = await fetchFn(
    `${env.apiBaseUrl}/pages/${encodeURIComponent(pageObjectId)}/snapshots/${encodeURIComponent(snapshotId)}`,
    { headers: authHeaders(token) },
  );
  if (!res.ok) throw new Error(`Failed to load snapshot html: ${res.status}`);
  const body = await res.json();
  return typeof body?.html === 'string' ? body.html : '';
}
